module.exports = __webpack_public_path__ + "static/media/msLogoGreen.18c5c76a.svg";